// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__CM5BJ","dashboardHeader":"Dashboard_dashboardHeader__EuVmg","dashboardFooter":"Dashboard_dashboardFooter__KNt8R"};